module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._v("\n        Filter By\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(this.$store.state.user.type == 'admin') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": function($event) {
        return _vm.getBranchWiseRecord(_vm.branch)
      }
    },
    model: {
      value: (_vm.branchDetail),
      callback: function($$v) {
        _vm.branchDetail = $$v
      },
      expression: "branchDetail"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), (_vm.canAccess('areasurvey-view-any')) ? _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Area Survey List")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [(_vm.canAccess('areasurvey-create')) ? _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add New\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('label', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.per_page),
      expression: "per_page"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "name": "per_page",
      "aria-controls": "example1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.per_page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeFilter()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "input-group pull-right input-group-sm",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table_search),
      expression: "table_search"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "table_search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.table_search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.table_search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.rows.data), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s((index + _vm.pagination.from)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.areaName))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.branch.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.surveyDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.employee.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                " + _vm._s(row.status) + "\n              ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group dropup"
    }, [_vm._m(1, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu dropdown-menu-right",
      attrs: {
        "role": "menu"
      }
    }, [(_vm.canAccess('areasurvey-view')) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.viewModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye text-info"
    }, [_vm._v(" View")])])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('areasurvey-update')) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.editModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square text-primary"
    }, [_vm._v(" Update")])])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('areasurvey-approve')) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.approveModel(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check-square text-success"
    }, [_vm._v(" Approve")])])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('areasurvey-delete')) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.deleteModal(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash text-danger"
    }, [_vm._v(" Delete")])])]) : _vm._e()])])])])
  }), 0)])]), _vm._v(" "), (_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n            Showing " + _vm._s(_vm.pagination.from) + " to " + _vm._s(_vm.pagination.to) + " of " + _vm._s(_vm.pagination.total) + " entries\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "newModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(3), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Add New")]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Update")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.editMode ? _vm.updateGroup() : _vm.createGroup()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": function($event) {
        return _vm.getBranchWiseRecord(_vm.branch)
      }
    },
    model: {
      value: (_vm.branch),
      callback: function($$v) {
        _vm.branch = $$v
      },
      expression: "branch"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.surveyDate),
      expression: "form.surveyDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'surveyDate'
      ),
    },
    attrs: {
      "type": "date",
      "name": "surveyDate",
      "placeholder": "Enter Survey Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.surveyDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "surveyDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "surveyDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.areaName),
      expression: "form.areaName"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('areaName'),
    },
    attrs: {
      "type": "text",
      "name": "areaName",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.areaName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "areaName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "areaName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.villageName),
      expression: "form.villageName"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('villageName'),
    },
    attrs: {
      "type": "text",
      "name": "villageName",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.villageName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "villageName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "villageName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Population Of Villages")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.populationOfVillage),
      expression: "form.populationOfVillage"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('populationOfVillage'),
    },
    attrs: {
      "type": "text",
      "name": "populationOfVillage",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.populationOfVillage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "populationOfVillage", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "populationOfVillage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Political Situation")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.politicalSituation),
      expression: "form.politicalSituation"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('politicalSituation'),
    },
    attrs: {
      "type": "text",
      "name": "politicalSituation",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.politicalSituation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "politicalSituation", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "politicalSituation"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Law And Order Situation")]), _vm._v(" "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.lawAndOrderSituation),
      expression: "form.lawAndOrderSituation"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('lawAndOrderSituation'),
    },
    attrs: {
      "type": "text",
      "name": "lawAndOrderSituation",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.lawAndOrderSituation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "lawAndOrderSituation", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "lawAndOrderSituation"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.generalCastPercentage),
      expression: "form.generalCastPercentage"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'generalCastPercentage'
      ),
    },
    attrs: {
      "type": "text",
      "name": "generalCastPercentage"
    },
    domProps: {
      "value": (_vm.form.generalCastPercentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "generalCastPercentage", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "generalCastPercentage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.obcCastPercentage),
      expression: "form.obcCastPercentage"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'obcCastPercentage'
      ),
    },
    attrs: {
      "type": "text",
      "name": "obcCastPercentage"
    },
    domProps: {
      "value": (_vm.form.obcCastPercentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "obcCastPercentage", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "obcCastPercentage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.scCastPercentage),
      expression: "form.scCastPercentage"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'scCastPercentage'
      ),
    },
    attrs: {
      "type": "text",
      "name": "scCastPercentage"
    },
    domProps: {
      "value": (_vm.form.scCastPercentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "scCastPercentage", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "scCastPercentage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.stCastPercentage),
      expression: "form.stCastPercentage"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'stCastPercentage'
      ),
    },
    attrs: {
      "type": "text",
      "name": "stCastPercentage"
    },
    domProps: {
      "value": (_vm.form.stCastPercentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "stCastPercentage", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "stCastPercentage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.otherCastPercentage),
      expression: "form.otherCastPercentage"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'otherCastPercentage'
      ),
    },
    attrs: {
      "type": "text",
      "name": "otherCastPercentage"
    },
    domProps: {
      "value": (_vm.form.otherCastPercentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "otherCastPercentage", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "otherCastPercentage"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.distanceFromBranch),
      expression: "form.distanceFromBranch"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('distanceFromBranch'),
    },
    attrs: {
      "type": "text",
      "name": "distanceFromBranch",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.distanceFromBranch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "distanceFromBranch", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "distanceFromBranch"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.possibleCenters),
      expression: "form.possibleCenters"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('possibleCenters'),
    },
    attrs: {
      "type": "text",
      "name": "possibleCenters",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.possibleCenters)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "possibleCenters", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "possibleCenters"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.mfiWorking),
      expression: "form.mfiWorking"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('mfiWorking'),
    },
    attrs: {
      "type": "text",
      "name": "mfiWorking",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.mfiWorking)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "mfiWorking", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "mfiWorking"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(15), _c('br'), _vm._v(" "), _vm._l((_vm.form.mfiNames), function(input, k) {
    return _c('span', {
      key: k,
      staticStyle: {
        "display": "flex",
        "flex-flow": "row wrap",
        "align-items": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.mfiNem),
        expression: "input.mfiNem"
      }],
      staticClass: "form-control",
      class: {
        'is-invalid': _vm.form.errors.has('mfiNem'),
      },
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "type": "text",
        "name": "mfiNem",
        "placeholder": "Micro Finance Name"
      },
      domProps: {
        "value": (input.mfiNem)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "mfiNem", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('has-error', {
      attrs: {
        "form": _vm.form,
        "field": "mfiNem"
      }
    }), _vm._v("\n                            \n                               \n                                "), _c('span', [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (k || (!k && _vm.form.mfiNames.length > 1)),
        expression: "k || ( !k && form.mfiNames.length > 1)"
      }],
      staticClass: "fa fa-minus-circle btn-danger",
      on: {
        "click": function($event) {
          return _vm.remove(k)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (k == _vm.form.mfiNames.length - 1),
        expression: "k == form.mfiNames.length-1"
      }],
      staticClass: "fa fa-plus-circle btn-success",
      on: {
        "click": function($event) {
          return _vm.add(k)
        }
      }
    })])], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(16), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.majorOperationPeople),
      expression: "form.majorOperationPeople"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'majorOperationPeople'
      ),
    },
    attrs: {
      "type": "text",
      "name": "majorOperationPeople"
    },
    domProps: {
      "value": (_vm.form.majorOperationPeople)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "majorOperationPeople", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "majorOperationPeople"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.roadStatus),
      expression: "form.roadStatus"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'roadStatus'
      ),
    },
    attrs: {
      "type": "text",
      "name": "roadStatus"
    },
    domProps: {
      "value": (_vm.form.roadStatus)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "roadStatus", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "roadStatus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(18), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.hinduReligionPercentage),
      expression: "form.hinduReligionPercentage"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'hinduReligionPercentage'
      ),
    },
    attrs: {
      "type": "text",
      "name": "hinduReligionPercentage"
    },
    domProps: {
      "value": (_vm.form.hinduReligionPercentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "hinduReligionPercentage", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "hinduReligionPercentage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(19), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.muslimReligionPercentage),
      expression: "form.muslimReligionPercentage"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'muslimReligionPercentage'
      ),
    },
    attrs: {
      "type": "text",
      "name": "muslimReligionPercentage"
    },
    domProps: {
      "value": (_vm.form.muslimReligionPercentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "muslimReligionPercentage", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "muslimReligionPercentage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.sikhReligionPercentage),
      expression: "form.sikhReligionPercentage"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'sikhReligionPercentage'
      ),
    },
    attrs: {
      "type": "text",
      "name": "sikhReligionPercentage"
    },
    domProps: {
      "value": (_vm.form.sikhReligionPercentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "sikhReligionPercentage", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "sikhReligionPercentage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(21), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.christianReligionPercentage),
      expression: "form.christianReligionPercentage"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'christianReligionPercentage'
      ),
    },
    attrs: {
      "type": "text",
      "name": "christianReligionPercentage"
    },
    domProps: {
      "value": (_vm.form.christianReligionPercentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "christianReligionPercentage", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "christianReligionPercentage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(22), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.otherReligionPercentage),
      expression: "form.otherReligionPercentage"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'otherReligionPercentage'
      ),
    },
    attrs: {
      "type": "text",
      "name": "otherReligionPercentage"
    },
    domProps: {
      "value": (_vm.form.otherReligionPercentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "otherReligionPercentage", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "otherReligionPercentage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Remark")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.remark),
      expression: "form.remark"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'remark'
      ),
    },
    attrs: {
      "type": "text",
      "name": "remark"
    },
    domProps: {
      "value": (_vm.form.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "remark", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "remark"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  SAVE\n                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  UPDATE\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                  CANCEL\n                ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('ul', {
    staticClass: "list-group mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Branch Name")]), _vm._v(" "), (_vm.record.branch) ? _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.branch.name))]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Employee Name")]), _vm._v(" "), (_vm.record.employee) ? _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.employee.name))]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Approved Name")]), _vm._v(" "), (_vm.record.approved_by) ? _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.approved_by.name))]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Hindu Religion (%)")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.hinduReligionPercentage))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Muslim Religion (%)")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.muslimReligionPercentage))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Sikh Religion (%)")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.sikhReligionPercentage))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Christian Religion (%)")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.christianReligionPercentage))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Other Religion (%)")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.otherReligionPercentage))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("General Caste (%)")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.generalCastPercentage))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("OBC Caste (%)")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.obcCastPercentage))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("SC Caste (%)")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.scCastPercentage))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("ST Caste (%)")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.stCastPercentage))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Other Caste (%)")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.otherCastPercentage))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [_c('ul', {
    staticClass: "list-group mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Area Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.areaName))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Village Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.villageName))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Distance From Branch")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.distanceFromBranch))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Road Status")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.roadStatus))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Political Situation")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.politicalSituation))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Low and Order Situation")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.lawAndOrderSituation))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Major Operation People")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.majorOperationPeople))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Possible Center")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.possibleCenters))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("MFI Working")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.mfiWorking))])]), _vm._v(" "), (_vm.mfinams) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("MFI Name ")]), _vm._v(" "), _vm._l((_vm.mfinams), function(mfinm, index) {
    return _c('i', {
      key: index
    }, [_c('br'), _vm._v(" " + _vm._s(index + 1) + " - " + _vm._s(mfinm.mfiNem) + " \n                          ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Remark ")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.remark))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Status")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.record.status))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Create Date")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("myDate")(_vm.record.created_at)))])])])])])])])]), _vm._v(" "), _vm._m(24)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr. No.")]), _vm._v(" "), _c('th', [_vm._v("Area Name")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Branch")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Survey Date")]), _vm._v(" "), _c('th', [_vm._v("Employee ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-flat btn-xs dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                    Task "), _c('span', {
    staticClass: "caret"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                              Survey Date\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Area Name "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Village Name "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("General Caste Percentage %\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("OBC Caste Percentage %\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("SC Caste Percentage %\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("ST Caste Percentage %\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Other Caste Percentage %\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Distance From Branch "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Possible Center "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("MFI Working "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("MFI Name "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Major Operation People\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Road Status\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Hindu Religion Percentage %\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Muslim Religion Percentage %\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Sikh Religion Percentage %\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Christian Religion Percentage %\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Other Religion Percentage %\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Area Survey Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CLOSE\n              ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0cc3691c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/master/company/AreaSurvey.vue
// module id = 805
// module chunks = 0